import { ICustomerDetailDisplay } from 'design-v2/common/CustomerTab/types';
import IconsService from 'external-services/icons-service';
import style from 'design-v2/common/CustomerTab/style.module.css';
import { Typography } from '@material-ui/core';
import classNames from 'classnames';
import color from 'design-v2/globals/colors/colors.module.css';
import React from 'react';

const CustomerDetailDisplay = (props: ICustomerDetailDisplay) => {
  const {icon, detail, tailPart, includeIcons, label, iconStyle = {width:24, height: 24}} = props;
  const Icon = IconsService.getIcon(icon);

  return (
    <div>
      <div className={style.spaceBtw}>
        <div className={style.rowItem}>
          <div className={classNames({
            [style.rightSpace]: true,
          })}>
            {icon && <Icon
              className={classNames({
                [color.clrGreyHeavy]: true,
              })}
            />}
            {!icon && <div style={iconStyle}>{props.muiIcon}</div>}
          </div>
          {includeIcons ? (<Typography>
              {detail ? <span className={style.detailText}>{detail}</span> : <span className={style.greyColor}>{label}</span>}
            </Typography>) :
            (<Typography className={classNames({
            [style.greyColor]: true,
          })}>{detail}</Typography>)}
        </div>
        <div className={classNames({
          [style.visitCountBox]: true,
          [style.greyColor]: true,
        })}>
          {tailPart && (
            <span>{tailPart}</span> )}
        </div>
      </div>
      <div className={style.divider}></div>
    </div>
  )
}

export default CustomerDetailDisplay;
